import { gql, TypedDocumentNode } from "@apollo/client";

import {
  ClientSchemaQuery,
  ClientSchemaQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { propertyFragment } from "src/graphql/anti-fraud/fragments/PropertyFragment";
import { useFetchQuery } from "src/graphql/utils/useFetchQuery.ts";
import { mapToProperty } from "src/mappers/property.mappers";
import { ClientSchema } from "src/types/clientSchema";

export const getClientSchemaQuery = gql`
  query ClientSchema {
    schema {
      caseTypes {
        name
        code
        properties {
          ...PropertyFragment
        }
      }
      elementTypes {
        name
        code
        properties {
          ...PropertyFragment
        }
        elements {
          name
          code
          elementType {
            name
            code
            properties {
              ...PropertyFragment
            }
          }
        }
      }
    }
  }
  ${propertyFragment}
` as TypedDocumentNode<ClientSchemaQuery, ClientSchemaQueryVariables>;

export const useClientSchemaQuery = () => {
  return useFetchQuery(getClientSchemaQuery, {
    toData: (data) => {
      return (
        (data?.schema &&
          ({
            caseTypes: data.schema.caseTypes.map((caseType) => ({
              name: caseType.name,
              code: caseType.code,
              properties: caseType.properties.map(mapToProperty),
            })),
            elementTypes: data.schema.elementTypes.map((elementType) => ({
              name: elementType.name,
              code: elementType.code,
              properties: elementType.properties.map(mapToProperty),
              elements: elementType.elements?.map((el) => ({
                name: el.name,
                code: el.code,
                elementType: {
                  name: el.elementType.name,
                  code: el.elementType.code,
                },
              })),
            })),
          } satisfies ClientSchema)) ??
        undefined
      );
    },
    isEmpty: (data) => !data?.schema,
    uiErrors: {
      fetchError: "FETCH-LIST-TYPES-ERROR",
    },
  });
};
